function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"));
}
const trapFocusHandlers = {},
    warningTime = 3e3;
function trapFocus(e, t = e) {
    var n = getFocusableElements(e),
        o = n[0],
        i = n[n.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== i && t.target !== o) || document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() && (t.target !== i || t.shiftKey || (t.preventDefault(), o.focus()), (t.target !== e && t.target !== o) || !t.shiftKey || (t.preventDefault(), i.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus();
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => e.modelViewerUI?.pause());
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus();
}
function debounce(e, t) {
    let n;
    return (...o) => {
        clearTimeout(n), (n = setTimeout(() => e.apply(this, o), t));
    };
}
const serializeForm = (e) => {
    const t = {},
        n = new FormData(e);
    for (const e of n.keys()) t[e] = n.get(e);
    return JSON.stringify(t);
};
function throttle(e, t) {
    let n = 0;
    return function (...o) {
        const i = new Date().getTime();
        if (!(i - n < t)) return (n = i), e(...o);
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
function extractContent(e) {
    var t = document.createElement("div");
    return (t.innerHTML = e), t.textContent || t.innerText;
}
function getCartUpdate(e, t, n) {
    const o = JSON.stringify({ line: e, quantity: t, sections_url: window.location.pathname });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: o })
        .then((e) => e.text())
        .then((e) => {
            const t = JSON.parse(e);
            t.errors ? showWarning("Error : " + t.errors, warningTime) : "function" == typeof n ? n(t) : Shopify.onCartUpdate(t);
        })
        .catch((e) => {
            console.error(e);
        });
}
void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var n = 0, o = e.options.length; n < o; n++) {
            var i = e.options[n];
            if (t == i.value || t == i.innerHTML) return (e.selectedIndex = n), n;
        }
    }),
    (Shopify.addListener = function (e, t, n) {
        e.addEventListener ? e.addEventListener(t, n, !1) : e.attachEvent("on" + t, n);
    }),
    (Shopify.postLink = function (e, t) {
        var n = (t = t || {}).method || "post",
            o = t.parameters || {},
            i = document.createElement("form");
        for (var r in (i.setAttribute("method", n), i.setAttribute("action", e), o)) {
            var s = document.createElement("input");
            s.setAttribute("type", "hidden"), s.setAttribute("name", r), s.setAttribute("value", o[r]), i.appendChild(s);
        }
        document.body.appendChild(i), i.submit(), document.body.removeChild(i);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, n) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(n.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = (i = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                n = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), n && 0 == n.length)) this.provinceContainer.style.display = "none";
            else {
                for (var o = 0; o < n.length; o++) {
                    var i;
                    ((i = document.createElement("option")).value = n[o][0]), (i.innerHTML = n[o][1]), this.provinceEl.appendChild(i);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            var n = 0;
            for (t.length; n < t.length; n++) {
                var o = document.createElement("option");
                (o.value = t[n]), (o.innerHTML = t[n]), e.appendChild(o);
            }
        },
    }),
    (Shopify.formatMoney = function (e, t) {
        "string" == typeof e && (e = e.replace(".", ""));
        var n = "",
            o = /\{\{\s*(\w+)\s*\}\}/,
            i = t || this.money_format;
        function r(e, t) {
            return void 0 === e ? t : e;
        }
        function s(e, t, n, o) {
            if (((t = r(t, 2)), (n = r(n, ",")), (o = r(o, ".")), isNaN(e) || null == e)) return 0;
            var i = (e = (e / 100).toFixed(t)).split(".");
            return i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) + (i[1] ? o + i[1] : "");
        }
        switch (i.match(o)[1]) {
            case "amount":
                n = s(e, 2);
                break;
            case "amount_no_decimals":
                n = s(e, 0);
                break;
            case "amount_with_comma_separator":
                n = s(e, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                n = s(e, 0, ".", ",");
        }
        return i.replace(o, n);
    }),
    (Shopify.getCart = function (e) {
        $.getJSON("/cart.js", function (t, n) {
            "function" == typeof e ? e(t) : Shopify.onCartUpdate(t);
        });
    }),
    (Shopify.onCartUpdate = function (e) {
        alert("There are now " + e.item_count + " items in the cart.");
    }),
    (Shopify.changeItem = function (e, t, n, o) {
        getCartUpdate(n, t, o);
    }),
    (Shopify.removeItem = function (e, t, n) {
        getCartUpdate(t, 0, n);
    }),
    (Shopify.addItem = function (e, t, n, o, i = null) {
        let r = "quantity=" + (t = t || 1) + "&id=" + e;
        if (n.closest("form")) {
            const e = n.closest("form").find('[name^="properties"]');
            e.length &&
                e.each((e, t) => {
                    r = `${r}&${$(t).attr("name")}=${$(t).val()}`;
                });
        }
        var s = {
            type: "POST",
            url: "/cart/add.js",
            data: r,
            dataType: "json",
            success: function (e) {
                "function" == typeof o ? o(e) : Shopify.onItemAdded(e);
            },
            error: function (e, t) {
                var o = window.cartStrings.addProductOutQuantity2;
                if (i.length > 0) {
                    var r = parseInt(i.attr("data-inventory-quantity"));
                    (o = getInputMessage(r)), i.val(r);
                }
                Shopify.onError(e, t, o), n.removeClass("is-loading");
            },
        };
        $.ajax(s);
    }),
    (Shopify.onItemAdded = function (e) {
        alert(e.title + " was added to your shopping cart.");
    }),
    (Shopify.onError = function (XMLHttpRequest, textStatus, message) {
        var data = eval("(" + XMLHttpRequest.responseText + ")");
        data.message ? (data.description ? showWarning(data.description) : showWarning(data.message + ": " + message, warningTime)) : showWarning("Error : " + message, warningTime);
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details"));
        const e = this.querySelectorAll("summary");
        this.addAccessibilityAttributes(e),
            "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onCloseButtonClick.bind(this)));
    }
    addAccessibilityAttributes(e) {
        e.forEach((e) => {
            e.setAttribute("role", "button"), e.setAttribute("aria-expanded", !1), e.setAttribute("aria-controls", e.nextElementSibling.id);
        });
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        const t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        const t = e.currentTarget,
            n = t.parentNode,
            o = n.hasAttribute("open");
        n === this.mainDetailsToggle
            ? (o && e.preventDefault(), o ? this.closeMenuDrawer(t) : this.openMenuDrawer(t))
            : (trapFocus(t.nextElementSibling, n.querySelector("button")),
              setTimeout(() => {
                  n.classList.add("menu-opening");
              }));
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add("overflow-hidden-mobile");
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1),
            document.body.classList.remove("overflow-hidden-mobile"),
            removeTrapFocus(t),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(e) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        const t = e.currentTarget.closest("details");
        this.closeSubmenu(t);
    }
    closeSubmenu(e) {
        e.classList.remove("menu-opening"), removeTrapFocus(), this.closeAnimation(e);
    }
    closeAnimation(e) {
        let t;
        const n = (o) => {
            void 0 === t && (t = o);
            o - t < 400 ? window.requestAnimationFrame(n) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
        };
        window.requestAnimationFrame(n);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(e) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add("overflow-hidden-mobile");
    }
}
customElements.define("header-drawer", HeaderDrawer);
class UpdateQuantity extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeCart = !1),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.querySelectorAll(".btn-quantity").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = e.target;
        let n = t.parentElement.querySelector(".quantity");
        const o = Number(n.value),
            i = Number(n.dataset.inventoryQuantity),
            r = t.closest(".product-form")?.querySelector("[data-btn-addtocart]");
        let s,
            a = !1;
        const c = (document.body.matches(".quickshop-popup-show") ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`])[
            document.body.matches(".quickshop-popup-show") ? this.closest(".productView-options").querySelector('[name="id"]').value : this.input.dataset.cartQuantityId
        ];
        if (((a = "false" == r?.dataset.available || null == r?.dataset.available), (s = t.matches(".plus") ? o + 1 : t.matches(".minus") ? o - 1 : o), s < 0 && (s = 1), s > i && a && "deny" == c)) {
            showWarning(getInputMessage(i), warningTime), (s = i);
        }
        (n.value = s),
            "number" == typeof this.changeCart && clearTimeout(this.changeCart),
            (this.changeCart = setTimeout(() => {
                t.matches(".btn-quantity") && this.input.dispatchEvent(this.changeEvent);
            }, 350));
    }
    quantityCheckedToBeContinue() {
        const e = window[`cart_selling_array_${this.dataset.product}`];
        return null != e && "continue" === e[this.querySelector('[name="quantity"]').dataset.cartQuantityId];
    }
}
class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.querySelectorAll(".btn-quantity").forEach((e) => e.addEventListener("click", this.onChangeQuantity.bind(this))),
            this.input.addEventListener("change", this.onChangeQuantity.bind(this));
    }
    onChangeQuantity(e) {
        e.preventDefault();
        const t = e.target;
        let n = t.parentElement.querySelector(".quantity");
        const o = Number(n.value),
            i = Number(n.dataset.inventoryQuantity),
            r = t.closest("[data-quickshop]").querySelector("[data-btn-addtocart]");
        let s;
        if (((s = t.matches(".plus") ? o + 1 : t.matches(".minus") ? o - 1 : o), s <= 0 && (s = 1), s > i && !r.matches(".button--pre-untrack"))) {
            showWarning(getInputMessage(i), warningTime), (s = i);
        }
        (n.value = s), t.matches(".btn-quantity") && this.input.dispatchEvent(this.changeEvent);
        this.closest("[data-quickshop]").querySelector('form input[type="hidden"]').setAttribute("value", s);
    }
}
class ProductScroller extends HTMLElement {
    constructor() {
        super(), (this.container = this.querySelector("[data-drag-container]")), (this.dragParent = this.querySelector("[data-drag-parent]")), this.initDragToScroll();
    }
    initDragToScroll() {
        var e;
        (e = this.container).clientWidth < e.scrollWidth ? this.dragToScroll(this.container) : this.dragToScroll(this.dragParent);
    }
    dragToScroll(e) {
        let t,
            n,
            o,
            i = !1;
        e.addEventListener("mousedown", (o) => {
            o.target;
            (i = !0), (t = o.pageX - e.offsetLeft), (n = e.scrollLeft);
        }),
            e.addEventListener("mouseup", () => {
                (i = !1),
                    clearTimeout(o),
                    (o = setTimeout(() => {
                        e.classList.remove("active");
                    }, 150));
            }),
            e.addEventListener("mousemove", (o) => {
                if (!i) return;
                o.preventDefault(), e.classList.contains("active") || e.classList.add("active");
                const r = 1 * (o.pageX - e.offsetLeft - t);
                e.scrollLeft = n - r;
            }),
            e.addEventListener("mouseleave", () => {
                (i = !1),
                    clearTimeout(o),
                    (o = setTimeout(() => {
                        e.classList.remove("active");
                    }, 150));
            });
    }
}
class ImageToFlip extends HTMLElement {
    constructor() {
        super(), (this.imageContainer = this), this.initObserver();
    }
    initObserver() {
        (this.observer = new IntersectionObserver(
            (e, t) => {
                const n = e[0];
                n.isIntersecting && (n.target.classList.add("show"), t.unobserve(n.target));
            },
            { threshold: 0.4 }
        )),
            this.observer.observe(this.imageContainer);
    }
}
function showWarning(e, t = null) {
    window.warningTimeout && clearTimeout(window.warningTimeout);
    (document.getElementById("halo-warning-popup").querySelector("[data-halo-warning-content]").textContent = e),
        document.body.classList.add("has-warning"),
        t &&
            (window.warningTimeout = setTimeout(() => {
                document.body.classList.remove("has-warning");
            }, t));
}
function getInputMessage(e) {
    return window.cartStrings.addProductOutQuantity.replace("[maxQuantity]", e);
}
window.addEventListener("load", () => {
    customElements.define("cart-update-quantity", UpdateQuantity), customElements.define("quickshop-update-quantity", UpdateQuantityQuickShop), customElements.define("product-scroller", ProductScroller);
});
class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.initObserver();
    }
    initObserver() {
        (this.observer = new IntersectionObserver(
            (e, t) => {
                e[0].isIntersecting && (this.classList.add("fade-in"), t.unobserve(this));
            },
            { threshold: 0.7 }
        )),
            this.observer.observe(this);
    }
}
function loadScrolling() {
    document.querySelectorAll("[data-scrolling]").forEach((e) => {
        "vertical" == e.dataset.scrolling ? this.scrollVertical(e) : this.scrollHorizontal(e);
    });
}
function scrollVertical(e) {
    const t = e.closest(".special-banner__item") || e,
        n = t.getBoundingClientRect().top,
        o = t.getBoundingClientRect().height,
        i = window.innerHeight,
        r = e.scrollHeight / o,
        s = o >= i ? 0 : (i - o) / 2;
    n - s < 0 && n > -1 * o ? this.scrollTop(e, (-1 * n + s) * r) : n - s >= 0 ? this.scrollTop(e, 0) : this.scrollTop(e, e.scrollHeight);
}
function scrollTop(e, t) {
    e.scrollTo({ top: t, behavior: "smooth" });
}
function scrollHorizontal(e) {
    const t = e.querySelector(".scrolling-text__list--1"),
        n = e.querySelector(".scrolling-text__list--2");
    if (!t) return;
    const o = e.getBoundingClientRect().top,
        i = e.getBoundingClientRect().height,
        r = window.innerHeight,
        s = t.scrollWidth > window.innerWidth ? t.scrollWidth - window.innerWidth : 0,
        a = 2 * t.getBoundingClientRect().height,
        c = i >= r ? 0 : (r - i) / 2,
        l = s / (i / 2 + c - a);
    let u = (-1 * o + c) * l,
        d = (i / 2 - a + c) * l - u;
    o - c < 0 && o - a > (-1 * i) / 2 ? ((u *= -1), (d *= -1)) : o - c >= 0 ? ((u = 0), (d = -1 * s)) : ((u = -1 * s), (d = 0)), t.scrollWidth <= window.innerWidth ? (n.style.justifyContent = "flex-end") : this.translateX(t, n, u, d);
}
function translateX(e, t, n, o) {
    (e.style.transform = `translateX(${n}px)`), (t.style.transform = `translateX(${o}px)`);
}
window.addEventListener("load", () => {
    customElements.define("fade-in-component", FadeInComponent), this.loadScrolling();
}),
    (window.onscroll = () => {
        this.loadScrolling();
    });
class SmoothScrollMenu {
    constructor(e) {
        (this.menuItems = document.querySelectorAll(e)), this.attachEvents(), this.hideMenuItemsWithoutSection();
    }
    attachEvents() {
        this.menuItems.forEach((e) => {
            const t = e.querySelector("a");
            t && t.getAttribute("href") && "#" !== t.getAttribute("href") && t.addEventListener("click", (e) => this.handleMenuItemClick(e, t));
        });
    }
    handleMenuItemClick(e, t) {
        e.preventDefault();
        var n = t.getAttribute("href"),
            o = !0;
        const i = window.location.pathname + window.location.hash;
        if ((n.includes("/") && i !== n && ((window.location.href = n), (o = !1)), o)) {
            var r = document.getElementById(t.getAttribute("href").split("#")[1]);
            r && this.scrollToSection(r);
        }
    }
    scrollToSection(e) {
        this.smoothScrollTo(e);
    }
    smoothScrollTo(e) {
        window.scrollTo({ behavior: "smooth", top: e.offsetTop });
    }
    hideMenuItemsWithoutSection() {
        this.menuItems.forEach((e) => {
            const t = e.querySelector("a").getAttribute("href").split("#")[1];
            void 0 === t || "" === t || document.getElementById(t) || (e.style.display = "none");
        });
    }
}
document.addEventListener("DOMContentLoaded", function () {
    new SmoothScrollMenu(".header__inline-menu .menu-lv-1"), customElements.define("details-disclosure", DetailsDisclosure);
});
class DetailsDisclosure extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details")), this.addEventListener("keyup", this.onKeyUp), this.mainDetailsToggle.addEventListener("focusout", this.onFocusOut.bind(this));
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        const t = e.target.closest("details[open]");
        if (!t) return;
        const n = t.querySelector("summary");
        t.removeAttribute("open"), n.focus();
    }
    onFocusOut() {
        setTimeout(() => {
            this.contains(document.activeElement) || this.close();
        });
    }
    close() {
        this.mainDetailsToggle.removeAttribute("open");
    }
}
class AccountIcon extends HTMLElement {
    constructor() {
        super(), (this.icon = this.querySelector(".icon"));
    }
    connectedCallback() {
        document.addEventListener("storefront:signincompleted", this.handleStorefrontSignInCompleted.bind(this));
    }
    handleStorefrontSignInCompleted(e) {
        e?.detail?.avatar && this.icon?.replaceWith(e.detail.avatar.cloneNode());
    }
}
customElements.define("account-icon", AccountIcon);
class PositiveVibesComponent extends HTMLElement {
    constructor() {
        super(), this.productPositiveVibes();
    }
    productPositiveVibes() {
        const e = this.querySelector(".text-vibes"),
            t = this.querySelectorAll(".text-vibes--child");
        let n = 0;
        if (t.length > 1) {
            const o = document.createElement("div");
            o.classList.add("text-vibes--child"), (o.innerHTML = t[0].innerHTML), e.appendChild(o);
            const i = e.querySelectorAll(".text-vibes--child");
            setInterval(() => {
                const t = i[n].offsetHeight;
                i.forEach((o, i) => {
                    (e.style.cssText = `transform: translateY(${t * -n}px); transition: all .5s ease;`), 0 == n && (e.style.cssText = `transform: translateY(${t * -n}px); transition: none;`);
                }),
                    (n = (n + 1) % i.length),
                    this.heightPositive();
            }, 3e3);
        }
    }
    heightPositive() {
        this.querySelector(".text-vibes");
        const e = this.querySelectorAll(".text-vibes--child");
        let t = 0;
        e.forEach((e) => {
            t = Math.max(t, e.querySelector("p").offsetHeight);
        }),
            (this.style.minHeight = t + "px"),
            e.forEach((e) => {
                e.style.minHeight = `${t}px`;
            });
    }
}
function checkTransparentHeader() {
    allowTransparent(),
        Shopify.designMode &&
            (document.addEventListener("shopify:section:load", allowTransparent), document.addEventListener("shopify:section:unload", allowTransparent), document.addEventListener("shopify:section:reorder", allowTransparent));
}
function allowTransparent() {
    document.querySelector(".shopify-section:first-child [allow-transparent-header]") || document.querySelector("body").removeAttribute("allow-transparency");
}
document.addEventListener("DOMContentLoaded", () => {
    customElements.define("positive-vibes", PositiveVibesComponent);
}),
    document.addEventListener("DOMContentLoaded", function () {
        checkTransparentHeader();
    });
const PUB_SUB_EVENTS = { cartUpdate: "cart-update", quantityUpdate: "quantity-update", optionValueSelectionChange: "option-value-selection-change", variantChange: "variant-change", cartError: "cart-error" };
let subscribers = {};
function subscribe(e, t) {
    return (
        void 0 === subscribers[e] && (subscribers[e] = []),
        (subscribers[e] = [...subscribers[e], t]),
        function () {
            subscribers[e] = subscribers[e].filter((e) => e !== t);
        }
    );
}
function publish(e, t) {
    subscribers[e] &&
        subscribers[e].forEach((e) => {
            e(t);
        });
}
class BulkAdd extends HTMLElement {
    constructor() {
        super(), (this.queue = []), (this.requestStarted = !1), (this.ids = []);
    }
    startQueue(e, t) {
        this.queue.push({ id: e, quantity: t });
        const n = setInterval(() => {
            this.queue.length > 0 ? this.requestStarted || this.sendRequest(this.queue) : clearInterval(n);
        }, 250);
    }
    sendRequest(e) {
        this.requestStarted = !0;
        const t = {};
        e.forEach((e) => {
            t[parseInt(e.id)] = e.quantity;
        }),
            (this.queue = this.queue.filter((t) => !e.includes(t)));
        (this.closest("quick-order-list") || this.closest("quick-add-bulk")).updateMultipleQty(t);
    }
    resetQuantityInput(e) {
        const t = this.querySelector(`#Quantity-${e}`);
        (t.value = t.getAttribute("value")), (this.isEnterPressed = !1);
    }
    setValidity(e, t, n) {
        e.target.setCustomValidity(n), e.target.reportValidity(), this.resetQuantityInput(t), e.target.select();
    }
    validateQuantity(e) {
        const t = parseInt(e.target.value),
            n = e.target.dataset.index;
        t < e.target.dataset.min
            ? this.setValidity(e, n, window.quickOrderListStrings.min_error.replace("[min]", e.target.dataset.min))
            : t > parseInt(e.target.max)
            ? this.setValidity(e, n, window.quickOrderListStrings.max_error.replace("[max]", e.target.max))
            : t % parseInt(e.target.step) != 0
            ? this.setValidity(e, n, window.quickOrderListStrings.step_error.replace("[step]", e.target.step))
            : (e.target.setCustomValidity(""), e.target.reportValidity(), this.startQueue(n, t));
    }
    getSectionsUrl() {
        return window.pageNumber ? `${window.location.pathname}?page=${window.pageNumber}` : `${window.location.pathname}`;
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
}
customElements.get("bulk-add") || customElements.define("bulk-add", BulkAdd),
    $(document).ready(function () {
        $(window).on("scroll", function () {
            $(window).scrollTop() > 100 ? $(".productView-buttons.desktop-view").css("z-index", "2") : $(".productView-buttons.desktop-view").css("z-index", "1");
        });
    }),
    $(document).ready(function () {
        function e(e, t) {
            return new Promise((n) => {
                !(function (e) {
                    e.attr("placeholder", "");
                })(t);
                let o = e.split("");
                o.reduce(
                    (e, i, r) =>
                        e.then(
                            (e) => (
                                r === o.length - 1 && setTimeout(n, 1e3),
                                (function (e, t) {
                                    return t.attr("placeholder", t.attr("placeholder") + e), new Promise((e) => setTimeout(e, 100));
                                })(i, t)
                            )
                        ),
                    Promise.resolve()
                );
            });
        }
        async function t(t, n) {
            for (;;) for (const o of t) await e(o, n);
        }
        !(async function () {
            await t(["Search For Rosemary", "Search For Sunscreen", "Search For Lip Balm", "Search For Moisturizer"], $("#Search-In-Modal-Classic"));
        })(),
            (async function () {
                await t(["Search For Rosemary", "Search For Sunscreen", "Search For Lip Balm", "Search For Moisturizer"], $("#Search-In-Modal"));
            })(),
            (async function () {
                await t(["Search For Rosemary", "Search For Sunscreen", "Search For Lip Balm", "Search For Moisturizer"], $("#Search-In-Modal-Sidebar"));
            })();
    });
